"use client";

import React from "react";
import { Facebook, Twitter, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const helpLinks = [{
  label: "Crawl Space Encapsulation",
  href: "/ServicesPage"
}, {
  label: "Vapor Barrier Install",
  href: "/ServicesPage"
}, {
  label: "Moisture Control",
  href: "/ServicesPage"
}, {
  label: "Foundation Repair",
  href: "/ServicesPage"
}, {
  label: "Free Inspection",
  href: "/ContactPage"
}];
const contactLinks = [{
  label: "Serving Greater Des Moines",
  href: "/ServiceAreasPage",
  icon: "chat"
}, {
  label: "Request Your Quote",
  href: "/ContactPage",
  icon: "form"
}];
const policyLinks = [{
  label: "About\xA0",
  href: "/AboutPage"
}, {
  label: "Service Areas",
  href: "/ServiceAreasPage"
}, {
  label: "Privacy Policy",
  href: "/PrivacyPolicy"
}, {
  label: "Terms of Service",
  href: "#"
}, {
  label: "Lead Generation Disclosure",
  href: "#"
}];
export default function Footer() {
  return <section data-section-id="170015" id="contactfooter" className="bg-sidebar text-sidebar-foreground border-t border-sidebar-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div className="hidden md:grid md:grid-cols-4 gap-12 mb-12">
          {}
          <div>
            <h3 className="font-bold text-sidebar-foreground tracking-tight mb-6">Our Services</h3>
            <ul className="space-y-3">
              {helpLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-bold text-sidebar-foreground tracking-tight mb-6">Contact Us</h3>
            <ul className="space-y-3">
              {contactLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors flex items-center gap-2">
                    {link.icon === "mail" && <Mail className="size-4" />}
                    {link.icon === "phone" && <Phone className="size-4" />}
                    {link.icon === "chat" && <span className="size-4 flex items-center justify-center text-xs"></span>}
                    {link.icon === "form" && <span className="size-4 flex items-center justify-center text-xs"></span>}
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-bold text-sidebar-foreground tracking-tight mb-6">Company</h3>
            <ul className="space-y-3">
              {policyLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              
            </Link>
            <p className="text-sm text-sidebar-foreground/60 leading-relaxed">Des Moines' trusted specialist for crawl space encapsulation and moisture control, protecting local homes from mold and structural damage.</p>
            
          </div>
        </div>

        {}
        <div className="md:hidden flex flex-col gap-8 mb-12">
          {}
          <div className="flex flex-col gap-6 items-center text-center px-4">
            <Link to="/HomePage" className="inline-block">
              <img src="/img/shopsphere_logo.png" alt="Home" className="h-8 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-sm text-sidebar-foreground/60 leading-relaxed">
              Serving Des Moines, West Des Moines, Ankeny, Urbandale, Waukee, and Johnston with professional crawl space solutions.
            </p>
            <div className="flex items-center justify-center gap-6 pt-2">
              <Link to="#" className="text-sidebar-foreground/50 hover:text-sidebar-primary transition-colors" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="#" className="text-sidebar-foreground/50 hover:text-sidebar-primary transition-colors" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="#" className="text-sidebar-foreground/50 hover:text-sidebar-primary transition-colors" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
            </div>
          </div>

          {}
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="help" className="border-sidebar-border">
              <AccordionTrigger className="text-sidebar-foreground font-bold hover:no-underline hover:text-sidebar-primary px-2">
                Our Services
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-3 pt-2 px-2">
                  {helpLinks.map((link, i) => <li key={i} data-index={i}>
                      <Link to={link.href} className="text-sm text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors block py-1">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="contact" className="border-sidebar-border">
              <AccordionTrigger className="text-sidebar-foreground font-bold hover:no-underline hover:text-sidebar-primary px-2">
                Contact Us
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-3 pt-2 px-2">
                  {contactLinks.map((link, i) => <li key={i} data-index={i}>
                      <Link to={link.href} className="text-sm text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors flex items-center gap-3 py-1">
                        {link.icon === "mail" && <Mail className="size-4" />}
                        {link.icon === "phone" && <Phone className="size-4" />}
                        {link.icon === "chat" && <span className="size-4 flex items-center justify-center text-xs"></span>}
                        {link.icon === "form" && <span className="size-4 flex items-center justify-center text-xs"></span>}
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="policies" className="border-sidebar-border">
              <AccordionTrigger className="text-sidebar-foreground font-bold hover:no-underline hover:text-sidebar-primary px-2">
                Company
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-3 pt-2 px-2">
                  {policyLinks.map((link, i) => <li key={i} data-index={i}>
                      <Link to={link.href} className="text-sm text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors block py-1">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>

        <Separator className="bg-sidebar-border" />

        {}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-sidebar-foreground/50">
          
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-sidebar-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-sidebar-primary transition-colors">Terms of Use</Link>
            <Link to="#" className="hover:text-sidebar-primary transition-colors font-mono uppercase tracking-tighter opacity-80">Consent Disclosure</Link>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-sidebar-border/30 text-center">
          <p className="text-xs text-sidebar-foreground/40">
            Iowa Crawlspace Solutions is a referral service that connects homeowners with licensed local contractors.
          </p>
        </div>

      </div>
    </section>;
}